export const QA_NAME_CALENDAR_GRID_DAY_LOAD_CHIP = 'calendarGridDayLoadChip'
